import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFortifyIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 56,
	height: 54,
	viewBox: "0 0 56 54",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M55.9743 0H0V25H31.8927C31.8927 25 42.6226 25 50.3255 15.8163C56.7087 8.20604 55.9743 0 55.9743 0Z",
		fill: "#0065FF"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M55.9743 29H0V54H31.8927C31.8927 54 42.6226 54 50.3255 44.8163C56.7087 37.206 55.9743 29 55.9743 29Z",
		fill: "#0065FF"
	})]
});
export default SvgFortifyIcon;
